<template>
  <div class="dialog-overlay">
    <div class="dialog-box p-4 animate-fade">
      <h5 class="fw-bold mb-3 text-gold">Add New Product</h5>

      <div class="mb-3">
        <input v-model="product.name" class="form-control elegant-input" placeholder="Name" />
      </div>
      <div class="mb-3">
        <textarea v-model="product.description" class="form-control elegant-input" placeholder="Description"></textarea>
      </div>
      <div class="mb-3">
        <input v-model.number="product.price" type="number" class="form-control elegant-input" placeholder="Price" />
      </div>
      <div class="mb-3">
        <input v-model="product.storeUrl" class="form-control elegant-input" placeholder="Store URL" />
      </div>

      <div class="mb-3">
        <label class="form-label fw-semibold text-secondary">Upload Image</label>
        <input type="file" @change="onFileSelected" accept="image/*" class="form-control" />
        <div v-if="previewUrl" class="mt-3 text-center">
          <img :src="previewUrl" class="img-thumbnail shadow-sm" style="max-height: 160px; border-radius: 10px;" />
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <button class="btn btn-outline-secondary me-2" @click="$emit('close')">Cancel</button>
        <button class="btn btn-gold" @click="saveProduct">Save Product</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      product: {
        name: "",
        description: "",
        price: null,
        storeUrl: ""
      },
      selectedFile: null,
      previewUrl: null
    };
  },
  methods: {
    onFileSelected(e) {
      this.selectedFile = e.target.files[0];
      this.previewUrl = URL.createObjectURL(this.selectedFile);
    },
    async saveProduct() {
      const toast = useToast();
      if (!this.product.name || !this.selectedFile) {
        toast.error("Please fill in the name and select an image!");
        return;
      }

      const formData = new FormData();
        formData.append("name", this.product.name);
        formData.append("description", this.product.description);
        formData.append("price", this.product.price);
        formData.append("storeUrl", this.product.storeUrl);
        formData.append("imageFile", this.selectedFile);

      await api.post("/Product/create", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      this.$emit("saved");
    }
  }
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex; justify-content: center; align-items: center;
  z-index: 1050;
}

.dialog-box {
  background: #fff;
  width: 500px;
  border-radius: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  border-top: 4px solid #c89d43;
}

.text-gold {
  color: #c89d43;
}

.elegant-input {
  border-radius: 8px;
  border: 1px solid #ddd;
  transition: all 0.3s ease;
}

.elegant-input:focus {
  border-color: #c89d43;
  box-shadow: 0 0 0 0.15rem rgba(200, 157, 67, 0.25);
}

.btn-gold {
  background-color: #c89d43;
  color: white;
  font-weight: 500;
  transition: background 0.3s ease;
}

.btn-gold:hover {
  background-color: #b0842d;
}

.animate-fade {
  animation: fadeIn 0.25s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
